import React from "react";

const QuestionImg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.83061 5.40321C7.24695 5.40321 6.77241 5.86927 6.77241 6.44251C6.77241 6.72994 6.53597 6.96216 6.24331 6.96216C5.95065 6.96216 5.71421 6.72994 5.71421 6.44251C5.71421 5.2944 6.66163 4.3639 7.83061 4.36228H8.35971C9.52869 4.36228 10.4761 5.29278 10.4761 6.44089V6.49935C10.4761 7.20737 10.109 7.86506 9.50389 8.2483L8.80614 8.68838C8.6937 8.75983 8.62426 8.88325 8.62426 9.01641V9.03915C8.62426 9.32658 8.38782 9.5588 8.09516 9.5588C7.8025 9.5588 7.56606 9.32658 7.56606 9.03915V9.01641C7.56606 8.53086 7.81738 8.07779 8.23405 7.81472L8.9318 7.37464C9.23438 7.18464 9.41791 6.85498 9.41791 6.50097V6.44251C9.41791 5.86927 8.94337 5.40321 8.35971 5.40321H7.83061Z"
        fill="var(--vc-violet)"
      />
      <path
        d="M8.56282 11.4488C8.43879 11.5706 8.27057 11.639 8.09516 11.639C7.91975 11.639 7.75153 11.5706 7.6275 11.4488C7.50346 11.327 7.43378 11.1617 7.43378 10.9895C7.43378 10.8172 7.50346 10.652 7.6275 10.5302C7.75153 10.4083 7.91975 10.3399 8.09516 10.3399C8.27057 10.3399 8.43879 10.4083 8.56282 10.5302C8.68685 10.652 8.75654 10.8172 8.75654 10.9895C8.75654 11.1617 8.68685 11.327 8.56282 11.4488Z"
        fill="var(--vc-violet)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.29588 2.45752C5.3922 1.72498 6.68113 1.33398 7.99968 1.33398C9.76779 1.33398 11.4635 2.03636 12.7137 3.28661C13.964 4.53685 14.6663 6.23254 14.6663 8.00065C14.6663 9.31919 14.2753 10.6081 13.5428 11.7045C12.8103 12.8008 11.7691 13.6553 10.5509 14.1598C9.33273 14.6644 7.99228 14.7965 6.69908 14.5392C5.40587 14.282 4.21798 13.647 3.28563 12.7147C2.35328 11.7823 1.71834 10.5945 1.46111 9.30125C1.20387 8.00805 1.3359 6.6676 1.84048 5.44943C2.34506 4.23125 3.19955 3.19006 4.29588 2.45752ZM4.82499 12.7519C5.7647 13.3798 6.8695 13.7149 7.99968 13.7149C9.5152 13.7149 10.9686 13.1129 12.0403 12.0413C13.1119 10.9696 13.714 9.51617 13.714 8.00065C13.714 6.87047 13.3788 5.76567 12.7509 4.82596C12.123 3.88625 11.2306 3.15384 10.1864 2.72134C9.14229 2.28884 7.99334 2.17568 6.88487 2.39616C5.77641 2.61665 4.75822 3.16088 3.95907 3.96004C3.15991 4.7592 2.61568 5.77739 2.39519 6.88585C2.1747 7.99431 2.28786 9.14326 2.72037 10.1874C3.15287 11.2316 3.88528 12.124 4.82499 12.7519Z"
        fill="var(--vc-violet)"
      />
    </svg>
  );
};

export default QuestionImg;
